export default {
	'weight-and-quality-certificates': 'Weight and quality certificates',
    'weight-and-quality-certificate': 'weight and quality certificate',
    'add-a-weight-and-quality-certificate': 'add a weight and quality certificate'
}